import {useEffect, useRef} from 'react'
import {useGameStore} from '../store/GameStoreContext'
import {useUIContext} from '../contexts/UIContext'

/**
 * @deprecated Only use until UIMGamePlayerInformation is converted to ReactJS
 */
export const usePortraitPlayerInformationContainerPosition = () => {
    const setPlayerInformationContainerPosition = useGameStore((state) => state.gamePortraitPlayerInformationLayout.setPlayerInformationContainerPosition)
    const resizeObserverRef = useRef<ResizeObserver | null>(null)
    const {isUserOnTablet} = useUIContext()

    useEffect(() => {
        const statusContainer = document.querySelector('[data-game-current-status-container]') as HTMLElement
        const uiGameContainer = document.getElementById('ui-game') as HTMLElement

        if(statusContainer == null || uiGameContainer == null) {
            setPlayerInformationContainerPosition(null)
            return
        }

        const updatePlayerInformationContainerPosition = () => {
            const currentStatusRect = statusContainer.getBoundingClientRect()
            const uiGameRect = uiGameContainer.getBoundingClientRect()
            const x = isUserOnTablet === true ? uiGameRect.width * 0.75 : 0

            const position = {
                x: x,
                y: (currentStatusRect.bottom - uiGameRect.top),
            }

            setPlayerInformationContainerPosition(position)
        }

        updatePlayerInformationContainerPosition()

        resizeObserverRef.current = new ResizeObserver(() => {
            updatePlayerInformationContainerPosition()
        })

        resizeObserverRef.current.observe(statusContainer)

        const handleResize = () => updatePlayerInformationContainerPosition()
        window.addEventListener('resize', handleResize)

        return () => {
            if(resizeObserverRef.current) resizeObserverRef.current.disconnect()
            window.removeEventListener('resize', handleResize)
        }
    }, [setPlayerInformationContainerPosition])
}
